// extracted by mini-css-extract-plugin
export default {"find":"Find_find__HLRdw","heading":"Find_heading__zONDu","text_bg":"Find_text_bg__GzBCR","slider_container":"Find_slider_container__bT9VC","card":"Find_card__eKOIb"};